var elementsForm,contLogin = 1;

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){
        $('input[name='+elementsForm[i]+']').removeClass('error');
        if ( $.trim($("input[name="+elementsForm[i]+']').val()) == "" ) {
            contLogin = 0;
            $('input[name='+elementsForm[i]+']').addClass('error');
        }
    }
    return contLogin;
}

$('input[type=checkbox]').on('change', function() {
    if($(this).val() == 'no'){
        $(this).val('si');
    }else{
        $(this).val('no');
    }
});

$('.submitContract').click(function () {
    $('#formContract').submit();
});

$('#formContract').on('submit',function (e) {
    e.preventDefault();

    elementsForm = [
        "date",
        "reference",
        "contract_company_info_business_name",
        "contract_company_info_nit",
        "contract_company_info_phone",
        "contract_company_info_city",
        "contract_company_info_address",
        "contract_company_info_web",
        "contract_authorizing_name",
        "contract_authorizing_identification",
        "contract_authorizing_position",
        "contract_authorizing_mail",
        "contract_authorizing_cellphone",
        "max_day",
        "aprox_day",
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);
    if(contLogin == 0)
    {
        swal({
            text: "Debes digitar todos los datos requeridos",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }

    var data = $(this).serialize();

    swal({
        text: "Estamos validando, espere un momento ...",
        icon: imageURL,
        button: false,
        closeOnClickOutside: false,
    });

    $.ajax({
        url: https + "contractRegister",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                //$("#formSignature")[0].reset();
                swal.close();
                swal({
                    text: "Contrato guardado con exito!",
                    icon: imageURL,
                    button: "OK!",
                });
                setTimeout(function () {
                    location.href = https + '';
                },1000);
            }else {
                swal({
                    text: "" + data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

let subtotal = 0,iva = 0,total = 0,iva_calculate = 0,value = 0;
let pay_1 = 0,pay_2=0,pay_3 = 0,pay_4=0;

/*
$('input[name=value_logo]').on('keypress', function(e) {
    if(e.which == 13) {
        if($('input[name=iva_logo]').val() == 'si'){
            iva_calculate = parseFloat($('input[name=value_logo]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
            iva = iva + iva_calculate;
        }else{
            iva_calculate = 0;
            iva = iva + iva_calculate;
        }
        value = parseFloat($('input[name=value_logo]').val());
        subtotal = subtotal + value;
        $('input[name=subtotal]').val(parseInt(subtotal));
        $('input[name=iva_total]').val(parseInt(iva));
        $('input[name=total]').val(parseInt(subtotal + iva));
    }
});
$('input[name=value_design_graphic_pieces]').on('keypress', function(e) {
    if(e.which == 13) {
        if($('input[name=iva_design_graphic_pieces]').val() == 'si'){
            iva_calculate = parseFloat($('input[name=value_design_graphic_pieces]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
            iva = iva + iva_calculate;
        }else{
            iva_calculate = 0;
            iva = iva + iva_calculate;
        }
        value = parseFloat($('input[name=value_design_graphic_pieces]').val());
        subtotal = subtotal + value;
        $('input[name=subtotal]').val(parseInt(subtotal));
        $('input[name=iva_total]').val(parseInt(iva));
        $('input[name=total]').val(parseInt(subtotal + iva));
    }
});
$('input[name=value_web_design]').on('keypress', function(e) {
    if(e.which == 13) {
        if($('input[name=iva_web_design]').val() == 'si'){
            iva_calculate = parseFloat($('input[name=value_web_design]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
            iva = iva + iva_calculate;
        }else{
            iva_calculate = 0;
            iva = iva + iva_calculate;
        }
        value = parseFloat($('input[name=value_web_design]').val());
        subtotal = subtotal + value;
        $('input[name=subtotal]').val(parseInt(subtotal));
        $('input[name=iva_total]').val(parseInt(iva));
        $('input[name=total]').val(parseInt(subtotal + iva));
    }
});
$('input[name=value_complementary]').on('keypress', function(e) {
    if(e.which == 13) {
        if($('input[name=iva_complementary]').val() == 'si'){
            iva_calculate = parseFloat($('input[name=value_complementary]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
            iva = iva + iva_calculate;
        }else{
            iva_calculate = 0;
            iva = iva + iva_calculate;
        }
        value = parseFloat($('input[name=value_complementary]').val());
        subtotal = subtotal + value;
        $('input[name=subtotal]').val(parseInt(subtotal));
        $('input[name=iva_total]').val(parseInt(iva));
        $('input[name=total]').val(parseInt(subtotal + iva));
    }
});
$('input[name=value_audiovisual_production]').on('keypress', function(e) {
    if(e.which == 13) {
        if($('input[name=iva_audiovisual_production]').val() == 'si'){
            iva_calculate = parseFloat($('input[name=value_audiovisual_production]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
            iva = iva + iva_calculate;
        }else{
            iva_calculate = 0;
            iva = iva + iva_calculate;
        }
        value = parseFloat($('input[name=value_audiovisual_production]').val());
        subtotal = subtotal + value;
        $('input[name=subtotal]').val(parseInt(subtotal));
        $('input[name=iva_total]').val(parseInt(iva));
        $('input[name=total]').val(parseInt(subtotal + iva));
    }
});
$('input[name=value_management_rrss]').on('keypress', function(e) {
    if(e.which == 13) {
        if($('input[name=iva_management_rrss]').val() == 'si'){
            iva_calculate = parseFloat($('input[name=value_management_rrss]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
            iva = iva + iva_calculate;
        }else{
            iva_calculate = 0;
            iva = iva + iva_calculate;
        }
        value = parseFloat($('input[name=value_management_rrss]').val());
        subtotal = subtotal + value;
        $('input[name=subtotal]').val(parseInt(subtotal));
        $('input[name=iva_total]').val(parseInt(iva));
        $('input[name=total]').val(parseInt(subtotal + iva));
    }
});
$('input[name=value_digital_marketing]').on('keypress', function(e) {
    if(e.which == 13) {
        if($('input[name=iva_digital_marketing]').val() == 'si'){
            iva_calculate = parseFloat($('input[name=value_digital_marketing]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
            iva = iva + iva_calculate;
        }else{
            iva_calculate = 0;
            iva = iva + iva_calculate;
        }
        value = parseFloat($('input[name=value_digital_marketing]').val());
        subtotal = subtotal + value;
        $('input[name=subtotal]').val(parseInt(subtotal));
        $('input[name=iva_total]').val(parseInt(iva));
        $('input[name=total]').val(parseInt(subtotal + iva));
    }
});
$('input[name=value]').on('keypress', function(e) {
    if(e.which == 13) {
        if($('input[name=iva]').val() == 'si'){
            iva_calculate = parseFloat($('input[name=value]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
            iva = iva + iva_calculate;
        }else{
            iva_calculate = 0;
            iva = iva + iva_calculate;
        }
        value = parseFloat($('input[name=value]').val());
        subtotal = subtotal + value;
        $('input[name=subtotal]').val(parseInt(subtotal));
        $('input[name=iva_total]').val(parseInt(iva));
        $('input[name=total]').val(parseInt(subtotal + iva));
    }
});
*/

$(document).ready(function () {
    if(window.location.href.replace(https,'').includes('create')){
        setInterval(function(){
        
        subtotal = 0,iva = 0,total = 0,iva_calculate = 0,value = 0;
        
        if($('input[name=value_logo]').val() != ""){
            if($('input[name=iva_logo]').val() == 'si'){
                iva_calculate = parseFloat($('input[name=value_logo]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
                iva = iva + iva_calculate;
            }else{
                iva_calculate = 0;
                iva = iva + iva_calculate;
            }
            value = parseFloat($('input[name=value_logo]').val());
            subtotal = subtotal + value;
        }

        if($('input[name=value_design_graphic_pieces]').val() != ""){
            if($('input[name=iva_design_graphic_pieces]').val() == 'si'){
                iva_calculate = parseFloat($('input[name=value_design_graphic_pieces]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
                iva = iva + iva_calculate;
            }else{
                iva_calculate = 0;
                iva = iva + iva_calculate;
            }
            value = parseFloat($('input[name=value_design_graphic_pieces]').val());
            subtotal = subtotal + value;
        }

        if($('input[name=value_web_design]').val() != ""){
            if($('input[name=iva_web_design]').val() == 'si'){
                iva_calculate = parseFloat($('input[name=value_web_design]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
                iva = iva + iva_calculate;
            }else{
                iva_calculate = 0;
                iva = iva + iva_calculate;
            }
            value = parseFloat($('input[name=value_web_design]').val());
            subtotal = subtotal + value;
        }

        if($('input[name=value_complementary]').val() != ""){
            if($('input[name=iva_complementary]').val() == 'si'){
                iva_calculate = parseFloat($('input[name=value_complementary]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
                iva = iva + iva_calculate;
            }else{
                iva_calculate = 0;
                iva = iva + iva_calculate;
            }
            value = parseFloat($('input[name=value_complementary]').val());
            subtotal = subtotal + value;
        }

        if($('input[name=value_audiovisual_production]').val() != ""){
            if($('input[name=iva_audiovisual_production]').val() == 'si'){
                iva_calculate = parseFloat($('input[name=value_audiovisual_production]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
                iva = iva + iva_calculate;
            }else{
                iva_calculate = 0;
                iva = iva + iva_calculate;
            }
            value = parseFloat($('input[name=value_audiovisual_production]').val());
            subtotal = subtotal + value;
        }

        if($('input[name=value_management_rrss]').val() != ""){
            if($('input[name=iva_management_rrss]').val() == 'si'){
                iva_calculate = parseFloat($('input[name=value_management_rrss]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
                iva = iva + iva_calculate;
            }else{
                iva_calculate = 0;
                iva = iva + iva_calculate;
            }
            value = parseFloat($('input[name=value_management_rrss]').val());
            subtotal = subtotal + value;
        }

        if($('input[name=value_digital_marketing]').val() != ""){
            if($('input[name=iva_digital_marketing]').val() == 'si'){
                iva_calculate = parseFloat($('input[name=value_digital_marketing]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
                iva = iva + iva_calculate;
            }else{
                iva_calculate = 0;
                iva = iva + iva_calculate;
            }
            value = parseFloat($('input[name=value_digital_marketing]').val());
            subtotal = subtotal + value;
        }

        if($('input[name=value]').val() != ""){
            if($('input[name=iva]').val() == 'si'){
                iva_calculate = parseFloat($('input[name=value]').val()) * parseFloat($('input[name=iva_cal]').val()) / 100;
                iva = iva + iva_calculate;
            }else{
                iva_calculate = 0;
                iva = iva + iva_calculate;
            }
            value = parseFloat($('input[name=value]').val()) + 0;
            subtotal = subtotal + value;
        }

        $('input[name=subtotal]').val(parseInt(subtotal));
        $('input[name=iva_total]').val(parseInt(iva));
        $('input[name=total]').val(parseInt(subtotal + iva));

        pay_1 = 0,pay_2=0,pay_3 = 0,pay_4=0;
        if($('input[name=payment_agreements_percent]').val() != ""){
            pay_1 = parseFloat($('input[name=total]').val()) * parseFloat($('input[name=payment_agreements_percent]').val()) / 100;
        }
        if($('input[name=payment_agreements_percent_2]').val() != ""){
            pay_2 = parseFloat($('input[name=total]').val()) * parseFloat($('input[name=payment_agreements_percent_2]').val()) / 100;
        }
        if($('input[name=payment_agreements_percent_3]').val() != ""){
            pay_3 = parseFloat($('input[name=total]').val()) * parseFloat($('input[name=payment_agreements_percent_3]').val()) / 100;
        }
        if($('input[name=payment_agreements_percent_4]').val() != ""){
            pay_4 = parseFloat($('input[name=total]').val()) * parseFloat($('input[name=payment_agreements_percent_4]').val()) / 100;
        }
        
        $('input[name=payment_agreements_value]').val(pay_1);
        $('input[name=payment_agreements_value_2]').val(pay_2);
        $('input[name=payment_agreements_value_3]').val(pay_3);
        $('input[name=payment_agreements_value_4]').val(pay_4);
        },1000);
    }
});